import './CartStepTwo.scss';
import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import { PaymentForm } from '../PaymentForm/PaymentForm';
import { OrderSummaryCardStatic } from '../OrderSummaryCards/OrderSummaryCardStatic/OrderSummaryCardStatic';

export const CartStepTwo = () => {
  return (
    <div className='payment-wrapper'>
      <OrderSummaryCardStatic />
      <RecurlyProvider publicKey={process.env.REACT_APP_RECURLY_PUBLIC_KEY}>
        <Elements>
          <PaymentForm />
        </Elements>
      </RecurlyProvider>
    </div>
  );
};
